<div>
    <h2 mat-dialog-title *ngIf="data.title">{{ data.title }}</h2>
    <mat-dialog-content *ngIf="data.message">{{ data.message }}</mat-dialog-content>
    <mat-dialog-actions>
        <button *ngFor="let button of buttonsMap; let i = index" mat-button mat-dialog-close="{{ i }}" [ngClass]="buttonClass(i, button)">{{ button.label }}</button>
    </mat-dialog-actions>
</div>